export const
    USER_ACHIEVEMENTS_PENDING = 'user_achievements_pending',
    USER_ACHIEVEMENTS_FAILED = 'user_achievements_failed',
    USER_ACHIEVEMENTS_DOWNLOADED = 'user_achievements_downloaded';



// WEBPACK FOOTER //
// src/store/userachievements/types.js